import {IntermediatePart} from "../../intermediatePart";
import isEqual from "lodash/isEqual";
import {METADATA} from "../../constants";

export default class Attachment extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "attachment";
    this.partName = "Attachment";
    this.hasAdditionalParts = true;
  }

  load(dbFeature) {
    if (!dbFeature.metaData["Side"] && dbFeature.sharedFeatureName.includes("ountertop")) {
      dbFeature.metaData["Side"] = [METADATA.LeftSide];
    }
    return super.load(dbFeature);
  }

  checkIfFeaturePartIsMatching() {
    this.activeFeatureParts = this.setActiveFeatureParts();
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Globals.Towel;
    }
    let increase = 0;
    if (this.hasAdditionalParts && this.activeFeatureParts && this.activeFeatureParts.length) {
      this.activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.layer.zIndex = zIndexes.Globals.Towel + increase;
        increase = increase + 0.000001;
      });
      // console.log("this.activeFeatureParts", this.activeFeatureParts);
    }
  }

  setActiveFeatureParts() {
    const layout = this.getParent().layout;
    const activeFeatures = layout.getActiveFeatures(true, true);
    let matchingFeatures = [];
    const currentConditions = this.getArrayOfConditions();
    const selectFrom = this.features.filter(attFeature => attFeature.matchesMetaForArrayOfConditions(currentConditions));
    // console.log("selectFrom", selectFrom);
    activeFeatures.forEach(cartItem => {
      if (!cartItem.cartFeature || cartItem.featureGroup.disabled || !cartItem.cartFeature.metaData["MatchingFeature"]
        || (cartItem.partId === this.partId)) {
        return
      }
      selectFrom.forEach(attFeature => {
        if (isEqual(attFeature.metaData["MatchingFeature"], cartItem.cartFeature.metaData["MatchingFeature"])
          && isEqual(attFeature.metaData["Side"], cartItem.cartFeature.metaData["Side"])
          && !matchingFeatures.some(alreadyAddedFeature => {
            return isEqual(attFeature.metaData["MatchingFeature"], alreadyAddedFeature.metaData["MatchingFeature"])
              && isEqual(attFeature.metaData["Side"], alreadyAddedFeature.metaData["Side"])
          })) {
          matchingFeatures.push(attFeature)
        }
      })
    })
    return matchingFeatures;
  }

}
